import { useQuery } from "@tanstack/react-query";
import { DocumentApiV2 } from "../../../../services/document/document-v2.service";
import { useSearchParams } from "../../../../hook/use-search-params";

export const useFolder2 = () => {
  const { searchParams } = useSearchParams();
  const folderId = searchParams.get("folderId");
  
  return useQuery({
    queryKey: ["folders", folderId],
    queryFn: () => DocumentApiV2.getItem(folderId!),
    enabled: Boolean(folderId),
  });
};
